import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PromisePool } from 'es6-promise-pool';
import {
  Button,
  Col,
  Container,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIactivateUser } from '../../../api/User';

import { addFlashMessage } from '../../../helpers/FlashMessages';

import ProcessingProgress from '../../ProcessingProgress';
import ProcessingSpinner from '../../ProcessingSpinner';

import ErrorBoundary from '../../ErrorBoundary';

class UserActivateModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      view: null,
      activating: false,
      updatedUsers: 0,
    };

    this.handleActivate = this.handleActivate.bind(this);
    this.resetView = this.resetView.bind(this);
  }

  getUsersPromisePool() {
    const { users } = this.props;

    let counterUsers = 0;
    const promiseProducerUsers = () => {
      if (counterUsers < users.length) {
        const user = users[counterUsers];
        counterUsers += 1;
        return APIactivateUser(user.uuid).then(() => {
          this.setState({ updatedUsers: counterUsers });
        });
      }
      return null;
    };

    return new PromisePool(promiseProducerUsers, 2);
  }

  handleActivate() {
    const {
      intl,
      users,
      handleClose,
      afterActivateUsers,
    } = this.props;

    this.setState({ activating: true });

    this.getUsersPromisePool().start().then(() => {
      addFlashMessage({
        type: 'success',
        text: intl.formatMessage({
          defaultMessage: '{count, plural, one {User has} other {Users have}} been re-activated',
        }, { count: users.length }),
      });
      afterActivateUsers();
      handleClose();
    }).catch(() => {
      this.setState({
        view: 'error',
        activating: false,
      });
    });
  }

  resetView(e) {
    e.preventDefault();
    this.setState({ view: null });
  }

  render() {
    const {
      view,
      activating,
      updatedUsers,
    } = this.state;
    const {
      intl,
      users,
      handleClose,
    } = this.props;

    return (
      <ErrorBoundary>
        <ModalHeader toggle={handleClose} className="modal-header-center">
          {intl.formatMessage({ defaultMessage: 'Re-activate {count, plural, one {user} other {users}}' }, { count: users.length })}
        </ModalHeader>

        {!view && (
          <ModalBody style={{ overflow: 'visible' }}>
            <p>
              {intl.formatMessage({
                defaultMessage: 'You are about to re-activate the following {count, plural, one {user} other {users}}:',
              }, { count: users.length })}
            </p>
            <ul>
              {users.map(u => (
                <li key={u.uuid}>
                  <strong>{u.name}</strong>
                </li>
              ))}
            </ul>
          </ModalBody>
        )}

        {(view === 'error' && !activating) && (
          <ModalBody className="modal-msg-body modal-msg-error">
            <Container>
              <Row>
                <Col>
                  {intl.formatMessage({
                    defaultMessage: 'Something went wrong. Please try again or contact us.',
                  })}
                </Col>
              </Row>
            </Container>
          </ModalBody>
        )}

        {!view && (
          <ModalFooter className="justify-r">
            <div className="buttons-group">
              <Button
                color="secondary"
                onClick={handleClose}
                disabled={activating}
              >
                {intl.formatMessage({ defaultMessage: 'Cancel' })}
              </Button>
              <Button
                color="primary"
                onClick={this.handleActivate}
                disabled={activating}
              >
                <ProcessingSpinner show={activating} />
                {intl.formatMessage({ defaultMessage: 'Re-activate' })}
                {users.length > 1 && (
                  <ProcessingProgress
                    show={activating}
                    progress={{ total: users.length, done: updatedUsers }}
                  />
                )}
              </Button>
            </div>
          </ModalFooter>
        )}

        {(view === 'error' && !activating) && (
          <ModalFooter className="justify-l">
            <div className="buttons-group">
              <Button color="link" onClick={this.resetView}>
                <i className="far fa-long-arrow-left" />
                {intl.formatMessage({ defaultMessage: 'Back' })}
              </Button>
            </div>
          </ModalFooter>
        )}
      </ErrorBoundary>
    );
  }
}

UserActivateModal.propTypes = {
  intl: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  users: PropTypes.array.isRequired,
  afterActivateUsers: PropTypes.func,
};

UserActivateModal.defaultProps = {
  afterActivateUsers: () => {},
};

export default injectIntl(UserActivateModal);
